import React, { Component } from 'react';

import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import ConfirmIcon from 'material-ui/svg-icons/navigation/check';
import TextField from 'material-ui/TextField';
import Select from '@material-ui/core/Select';
import { ListItem } from '@material-ui/core';
import * as esriLoader from 'esri-loader';
import ListItemText from '@material-ui/core/ListItemText';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

const paperStyle = {
  borderRadius: "0 0 2px 2px"
}

class EditOriginToolbar extends Component {

  constructor(props) {
    super(props);

    this.state =
    {
      ddFormat: 'dd',
      longitudeDisplay: this.props.longitude,
      latitudeDisplay: this.props.latitude,
      userLatValue: this.props.latitude,
      userLongValue: this.props.longitude
    };
  }

  updatePoint = () =>
  {
    esriLoader.loadModules(['esri/geometry/coordinateFormatter'])
    .then( ([coordinateFormatter]) =>
    {
      // Load dependencies of "coordinateFormatter" module
      coordinateFormatter.load().then(() =>
      {
        var newPoint = coordinateFormatter.fromLatitudeLongitude(this.state.userLatValue + " " + this.state.userLongValue);
        this.props.onUpdatePoint(newPoint);
     });
    });
  }

  handleChange = (event) =>
  {
      this.handleFormatChange(event.target.value);
  }

updateLongValue = (newLong) =>
{
  this.setState({
      userLongValue: newLong
  });

   this.updatePoint();
}

updateLatValue = (newLat) =>
{
  this.setState({
     userLatValue: newLat
 });

 this.updatePoint();
}

updateUserLatLong = (lat, long) =>
 {
   this.setState({
       userLatValue: lat,
       userLongValue:long
   });
 }

 handleFormatChange = (newFormat) =>
 {
      esriLoader.loadModules(['esri/geometry/Point', 'esri/geometry/SpatialReference', 'esri/geometry/coordinateFormatter'])
      .then( ([Point, SpatialReference, coordinateFormatter]) =>
      {
        let newPoint = new Point
        ({
         latitude: this.props.latitude,
         longitude: this.props.longitude,
         spatialReference:  new SpatialReference(4269)
        });

        // Load dependencies of "coordinateFormatter" module
        coordinateFormatter.load().then(() =>
        {
          var newString = coordinateFormatter.toLatitudeLongitude(newPoint, newFormat, 6);

          let lat = newString.substring(0, newString.indexOf("N") + 1);
          let long = newString.substring(lat.length+1);

          this.setState({
              ddFormat: newFormat
          });

          this.updateUserLatLong(lat,long);
       });
      });
    }

  render()
  {
    let originPerimeterWarning = (this.props.originWithinPerimeter) ? "" : (<p><b>WARNING: Origin is outside Perimeter</b></p>);

    return (
      <Paper className="edit-geometry-container edit-origin-container" zDepth={2} style={paperStyle}>

        <div className="edit-perimeter-actions">
        <Table selectable={false} style={{ tableLayout: 'auto' }} fixedHeader={false}>
          <TableBody displayRowCheckbox={false}>
        <TableRow>
        <TableRowColumn title="Cancel Origin Editing" >
        <IconButton onClick={this.props.onCancelOriginEdit}>
          <CloseIcon />
        </IconButton>
        </TableRowColumn>
        <TableRowColumn title="Confirm Origin">
        <IconButton onClick={this.props.onConfirmOriginEdit} disabled={this.props.confirmDisabled}>
          <ConfirmIcon />
        </IconButton>
        </TableRowColumn>
        <TableRowColumn>
        <Select onChange={this.handleChange} value={this.state.ddFormat}>
          <ListItem value='dd'>
           <ListItemText primary="Decimal Degrees" secondary="D.dd" />
          </ListItem>
          <ListItem value='ddm'>
           <ListItemText primary="Degrees Decimal Minutes" secondary="DM.mm" />
          </ListItem>
          <ListItem value='dms'>
           <ListItemText primary="Degrees Minutes Seconds" secondary="DMS.ss" />
          </ListItem>
          </Select>
        </TableRowColumn>
        <TableRowColumn>
          <TextField name="manualLongitude"
          value={this.state.userLongValue}
          onChange={(event, value) => {
              this.updateLongValue(value);
            }}/>
        </TableRowColumn>
        <TableRowColumn>
          <TextField name="manualLatitude"
          value={this.state.userLatValue}
          onChange={(event, value) => {
            this.updateLatValue(value);
          }}
           />
        </TableRowColumn>
          </TableRow>
        <TableRow>
        <TableRowColumn colSpan={3}><label className="detail-row-label">{originPerimeterWarning}</label></TableRowColumn>
        <TableRowColumn><label className="detail-row-label">Longitude</label></TableRowColumn>
        <TableRowColumn><label className="detail-row-label">Latitude</label></TableRowColumn>
          </TableRow>
          </TableBody>
        </Table>

        </div>
      </Paper>
    )
  }
}

export default EditOriginToolbar;
